<template>
<div class="profileForm">
  <form :action="action" :method="method" ref="profileForm">
    <input type="hidden" name="_token" :value="csrfToken">
    <div class="profileForm__form">
      <form-input
        :name="isTarget ? 'target_nickname' : 'nickname'"
        type="text"
        v-model="userInfo[`${isTarget ? 'target_' : ''}nickname`]"
        :label="isTarget ? 'ニックネーム':'ニックネーム（呼ばれたいお名前）'"
        placeholder="全角・半角英数字15文字以内"
        :validation="{ rules: {max: 15} }"
        />
      <div class="profileForm__form__set">
        <form-input
          :name="isTarget ? 'target_last_name' : 'last_name'"
          type="text"
          v-model="userInfo[`${isTarget ? 'target_' : ''}last_name`]"
          label="姓"
          :validation="{ rules: {max: 5} }"
          />
        <form-input
          :name="isTarget ? 'target_first_name' : 'first_name'"
          type="text"
          v-model="userInfo[`${isTarget ? 'target_' : ''}first_name`]"
          label="名"
          :validation="{ rules: {max: 5} }"
          />
      </div>
      <div class="profileForm__form__set">
        <form-input
          :name="isTarget ? 'target_last_name_kana' : 'last_name_kana'"
          type="text"
          v-model="userInfo[`${isTarget ? 'target_' : ''}last_name_kana`]"
          label="せい"
          :validation="{ rules: {max: 11, hiraganaOnly: true} }"
          />
        <form-input
          :name="isTarget ? 'target_first_name_kana' : 'first_name_kana'"
          type="text"
          v-model="userInfo[`${isTarget ? 'target_' : ''}first_name_kana`]"
          label="めい"
          :validation="{ rules: {max: 11, hiraganaOnly: true} }"
          />
      </div>
      <form-date
        :name="isTarget ? 'target_birthday' : 'birthday'"
        :is-required-label="isRegist"
        v-model="userInfo[`${isTarget ? 'target_' : ''}birthday`]"
        label="生年月日"
        />
      <form-time
        class="no-mb"
        :name="isTarget ? 'target_birthtime' : 'birthtime'"
        v-model="userInfo[`${isTarget ? 'target_' : ''}birthtime`]"
        :label="isTarget ? '出生時間' : '出生時間（母子手帳でご確認ください）'"
        />
      <p class="notes">※わからない場合は入力不要です。「17時台だけど分が不明」という場合は、17時00分とご入力ください。</p>
      <form-radio
        v-if="!isRegist"
        :name="isTarget ? 'target_gender' : 'gender'"
        v-model="userInfo[`${isTarget ? 'target_' : ''}gender`]"
        design="radio"
        label="性別"
        :default-no-check="true"
        :options="FORM_OPTIONS.gender"
        />
      <form-select
        v-if="!isRegist"
        :name="isTarget ? 'target_blood' : 'blood'"
        v-model="userInfo[`${isTarget ? 'target_' : ''}blood`]"
        label="血液型"
        :default-no-select="true"
        :options="FORM_OPTIONS.blood"
        />
      <form-radio
        v-if="!isRegist"
        :name="isTarget ? 'target_love_status' : 'love_status'"
        v-model="userInfo[`${isTarget ? 'target_' : ''}love_status`]"
        design="radio"
        label="結婚状況"
        :default-no-check="true"
        :options="FORM_OPTIONS.marriage_status"
        />
      <form-select
        :name="isTarget ? 'target_from_pref':'from_pref'"
        v-model="userInfo[`${isTarget ? 'target_' : ''}from_pref`]"
        label="出生地"
        :default-no-select="true"
        :options="FORM_OPTIONS.from_pref"
        />
      <form-select
        v-if="!isRegist"
        :name="isTarget ? 'target_living_place':'living_place'"
        v-model="userInfo[`${isTarget ? 'target_' : ''}living_place`]"
        label="現在のお住まい"
        :default-no-select="true"
        :options="FORM_OPTIONS.from_pref"
        />
      <form-select
        v-if="!isRegist"
        :name="isTarget ? 'target_birthorder':'birthorder'"
        v-model="userInfo[`${isTarget ? 'target_' : ''}birthorder`]"
        label="出まれ順"
        :default-no-select="true"
        :options="FORM_OPTIONS.birthorder"
        />
      <BaseButton class="profileForm__button" label="登録する" :is-disabled="buttonIsDisabled" @clicked="updateProfile"/>
    </div>
  </form>
  <BaseModal
    v-if="showModal"
    label="登録する"
    cancel="登録しない"
    @close="modalClose"
    href="/user/account/target_list">
    <p class="profileForm__modal">登録しました。<br>続けて「占いに使う相手の情報」を登録しますか？</p>
  </BaseModal>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { FORM_LABELS, FORM_OPTIONS, FORM_DATA } from '@/CONSTS'
import * as type from '@/utvStore/store/mutation-types'
import dataControl from './EntryForm/mixins/dataControl'
import fetchAccountData from '@/utils/fetchAccountData'
import convertUserInfo from '@/utils/convertUserInfo'
import BaseButton from './common/BaseButton'
import BaseModal from './common/BaseModal'

export default {
  name: 'profileForm',
  components:{
    BaseButton,
    BaseModal
  },
  props: {
    csrfToken: String,
    action: String,
    method: String,
    //相手の情報の場合はtrueにする
    isTarget: {
      type:Boolean,
      default:false
    },
    //登録の場合
    isRegist:{
      type:Boolean,
      default:false
    },
    profile:{
      type:Object,
      default:()=>{}
    }
  },
  data() {
    return {
      FORM_OPTIONS,
      buttonIsDisabled: false,
      validateFlags: {},
      showModal:false,
      userInfo:{},
    }
  },
  created(){
    if(!!this.profile) this.userInfo = Object.assign({}, this.profile)
    else this.userInfo = Object.assign({}, this.userAccount)

    // 登録true の場合は初期値を変更
    if (this.isRegist) {
      this.userInfo.love_status = ''
      this.userInfo.from_pref = ''
      this.userInfo.target_from_pref = ''
    }
  },
  mounted(){
    this.validateFlags = this.$validator.flags
  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      userAccount: state => state.account.profile
    }),
    ...mapGetters(['isLoggedIn'])
  },
  watch:{
    validateFlags: {
      handler(n,o) {
        this.buttonIsDisabled = Object.keys(n).some((key)=>{
          if(key === 'birthday' && this.isRegist){
            return !this.userInfo['birthday']
          }else{
            return n[key].invalid
          }
        })
      },
      deep: true
    }
  },
  methods: {
    updateProfile() {
      // 未ログイン(非会員状態)の場合は何もしない
      if (!this.isLoggedIn || !this.accessToken) return Promise.resolve()
      const formData = $(this.$refs.profileForm).serializeArray()
      formData.forEach(item => {
        Object.assign(data, {
          [item.name]: item.value
        })
      })
      data = convertUserInfo(data)
      this.$set(data, 'access_token', this.accessToken)
      if(data.partner_birth_date === 'Invalid date') this.$set(data, 'partner_birth_date', '')
      if(data.birth_date === 'Invalid date') this.$set(data, 'birth_date', '')
      if(this.isTarget) this.$set(data, 'friend_id', new URL(location.href).searchParams.get('friend_id'))
      fetchAccountData.updateProfile(data)
      .then(()=>{
        if(this.isTarget) location.href = '/user/account/target_list'
        else if(this.isRegist) this.$emit('next', this.userInfo)
        else this.showModal = true
      })
      .catch(err => console.log(err))
    },
    modalClose(){
      location.href = '/'
    }
  }
}</script>

<style lang="scss">
@import "../../../sass/commons/commonVariables.scss";
.profileForm{
  color: $col_base_black;
  padding: 35px 30px 45px;
  max-width: 580px;
  margin: auto;

  &__form{
    &__set{
      display: flex;
      div + div{
        margin-left: 3px;
      }
    }
  }

  &__modal{
    margin-bottom: 25px !important;
  }
  select.formControl {
    width: auto;
    padding-right: 32px;
  }
  .profileForm__button {
    margin: 35px 0 0;
    .baseButton__button {
      width: 100%;
    }
  }
  .no-mb {
    margin-bottom: 4px;
  }
  .notes {
    margin: 0 0 24px;
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ProfileForm.vue